import React from 'react';
import {
    Route,
    Routes,
} from "react-router-dom";
import ClassRoom from '../pages/virtualClassRoom';
import LogIn from '../pages/auth/components/login';
import GuestJoin from '../pages/auth/components/GuestJoin';
import AttendSession from '../pages/auth/components/AttendSession';
import Dashboard from '../pages/dashbord'
import Course from '../pages/Course'
import MyEvents from '../pages/events';
import MyCourses from '../pages/courses';
import Session from './../pages/session';
import ShareScreen from './../pages/virtualClassRoom/components/ShareScreen'
import ClassRoomDashboard from '../pages/classRoomDashboard';
import { useAuthContext } from '../pages/auth/hooks/useAuthContext';
import StudentShareScreen from '../pages/virtualClassRoom/helpers/studentShareScreen';

export default function Router() {
    const { user } = useAuthContext()
    return (
        <Routes>
            {/* Auth Routes */}
            <Route path="/" element={user ? <Dashboard /> : <LogIn />} />
            <Route path="/login" element={<LogIn />} />
            
            {/* Auto-login from website - uses token for authentication */}
            <Route path="/attend_session/:session_id/:token" element={<AttendSession />} />
            
            {/* Meeting/Guest Join Routes - allows quick access without full registration */}
            <Route path="/meeting/:meeting_id/:teacher_id" element={<GuestJoin />} />
            <Route path="/join/:meeting_id/:teacher_id" element={<GuestJoin />} />
            
            {/* Dashboard & Navigation */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/course_details/:id/:teacher_user_id" element={<Course />} />
            <Route path="/all_events" element={<MyEvents />} />
            <Route path="/all_courses" element={<MyCourses />} />
            
            {/* Virtual Classroom Routes */}
            <Route path="/class_room/:s_id/:tu_id" element={<ClassRoom />} />
            <Route path="/class_room_dashboard/:s_id" element={<ClassRoomDashboard />} />
            
            {/* Screen Sharing Routes */}
            <Route path="/share_screen/:room_id" element={<ShareScreen />} />
            <Route path="/share_screen_student/:room_id" element={<StudentShareScreen />} />
            
            {/* Session Route */}
            <Route path="/session/:id" element={<Session />} />
            
            {/* Catch-all redirect to login */}
            <Route path="*" element={user ? <Dashboard /> : <LogIn />} />
        </Routes>
    )
}
